import {Component, inject} from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {SSOService} from "../../../services/sso/SSOService";
import {ToastrService} from "ngx-toastr";
import {MatDialog} from "@angular/material/dialog";
import {RegisterConfirmComponent} from "../register-confirm/register-confirm.component";
import {NgxMaskDirective, NgxMaskPipe, provideNgxMask} from "ngx-mask";
import {MatButtonLoading} from "@ng-matero/extensions/button";
import {SessionManager} from "../../../manager/SessionManager";

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss'],
  standalone: true,
  imports: [
    RouterLink,
    FormsModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatButtonLoading,
  ],
  providers: [SSOService,provideNgxMask(),SessionManager]
})
export class RegisterComponent {
  private readonly fb = inject(FormBuilder);

  isLoading = false

  constructor(private ssoService: SSOService,
              private toastrService: ToastrService,
              private dialog: MatDialog,) {
  }

  registerForm = this.fb.nonNullable.group(
    {
      name: ['', [Validators.required, Validators.min(1)]],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.min(8)]],
      confirmPassword: ['', [Validators.required, Validators.min(8)]],
    },
    {
      validators: [this.matchValidator('password', 'confirmPassword')],
    }
  );

  matchValidator(source: string, target: string) {
    return (control: AbstractControl) => {
      const sourceControl = control.get(source)!;
      const targetControl = control.get(target)!;
      if (targetControl.errors && !targetControl.errors.mismatch) {
        return null;
      }
      if (sourceControl.value !== targetControl.value) {
        targetControl.setErrors({mismatch: true});
        return {mismatch: true};
      } else {
        targetControl.setErrors(null);
        return null;
      }
    };
  }

  register() {
    if (this.registerForm.valid) {
      this.isLoading = true
      this.ssoService
        .registerEmail(
          this.registerForm.controls.name.value,
          this.registerForm.controls.email.value,
          this.registerForm.controls.phone.value,
          this.registerForm.controls.password.value,
        ).subscribe(response => {
        this.isLoading = false
        this.dialog.open(RegisterConfirmComponent, {
          disableClose : true,
          data: {
            email: this.registerForm.controls.email.value
          }
        })
      },e => {
        this.isLoading = false
      })
    }
  }
}
